import React from 'react';
import PropTypes from 'prop-types';
import { branch, renderNothing } from 'recompose';

import { widgetsPropType, permissionPropType, userConfigPropType } from 'constants';
import UserButton from '../buttons/UserButton';
import AdminButton from '../buttons/AdminButton';
import CalendarButton from '../buttons/CalendarButton';
import ChatButton from '../buttons/ChatButton';
import NotificationButton from '../buttons/NotificationButton';
import SupportButton from '../buttons/SupportButton';
import VoiceButton from '../buttons/VoiceButton';

import './HeaderButtons.scss';

const HeaderButtons = ({ permissionProps, widgets, userConfig }) => {
  return (
    <div className="nx-global-header-buttons">
      {widgets.calendar && <CalendarButton widget={widgets.calendar} permissionProps={permissionProps} />}

      {widgets.chat && <ChatButton widget={widgets.chat} permissionProps={permissionProps} />}

      {widgets.notification && (
        <NotificationButton widget={widgets.notification} permissionProps={permissionProps} />
      )}

      {widgets.voice && <VoiceButton widget={widgets.voice} permissionProps={permissionProps} />}

      {widgets.support && <SupportButton widget={widgets.support} />}

      {widgets.admin && (
        <AdminButton
          widget={widgets.admin}
          permissionProps={permissionProps}
          className="nx-global-header-admin-tools"
        />
      )}

      {userConfig && <UserButton config={userConfig} />}
    </div>
  );
};

HeaderButtons.propTypes = {
  isLoading: PropTypes.bool, // eslint-disable-line react/no-unused-prop-types
  permissionProps: permissionPropType,
  widgets: widgetsPropType,
  userConfig: userConfigPropType,
};

export default branch((props) => props.isLoading, renderNothing)(HeaderButtons);
